import { AnalyticsWelcomeToastProps } from './types'
import {
  setAnalyticsWelcomeToastOpen,
  setAnalyticsWelcomeToastProps
} from '../../redux/slices/notifications/notificationsSlice'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

export const useSendAnalyticsWelcomeToastNotification = (): ((
  props: AnalyticsWelcomeToastProps
) => void) => {
  const dispatch = useDispatch()

  return useCallback(
    (welcomeToastProps: AnalyticsWelcomeToastProps) => {
      dispatch(setAnalyticsWelcomeToastProps(welcomeToastProps))
      dispatch(setAnalyticsWelcomeToastOpen(true))
    },
    [dispatch]
  )
}
